import * as fileApi from '@/api/datastore/generated/file/file';
import * as statusApi from '@/api/datastore/generated/status/status';
import * as jobLabelApi from '@/api/datastore/generated/job-label/job-label';
import * as jobTemplateApi from '@/api/datastore/generated/job-template/job-template';
import * as workflowApi from '@/api/datastore/generated/workflow/workflow';
import * as workflowRunApi from '@/api/datastore/generated/workflow-run/workflow-run';
import * as userApi from '@/api/datastore/generated/user/user';
import * as sasApi from '@/api/datastore/generated/sas/sas';
import * as promptApi from '@/api/datastore/generated/prompt/prompt';
import * as damageApi from '@/api/datastore/generated/damage/damage';
import * as userNotificationSettingApi from '@/api/datastore/generated/user-notification-setting/user-notification-setting';
import * as organizationNotificationSettingApi from '@/api/datastore/generated/organization-notification-setting/organization-notification-setting';
import * as workflowNotificationSettingApi from '@/api/datastore/generated/workflow-notification-setting/workflow-notification-setting';
import * as boxConnectionApi from '@/api/datastore/generated/box-connection/box-connection';
import * as boxImportRuleApi from '@/api/datastore/generated/box-import-rule/box-import-rule';
import * as boxExportRuleApi from '@/api/datastore/generated/box-export-rule/box-export-rule';
import * as exportRunApi from '@/api/datastore/generated/external-storage-export-run/external-storage-export-run';
import * as importRunApi from '@/api/datastore/generated/external-storage-import-run/external-storage-import-run';
import * as proxyApi from '@/api/datastore/generated/proxy/proxy';

// 内部で非同期処理は行わないため同期関数です（呼び出し側は `await` していても no-op になり互換）。
export function useDatastoreApi() {
  function useUserApi() {
    return userApi;
  }

  function useSasApi() {
    return sasApi;
  }

  function useFileApi() {
    return fileApi;
  }

  function useStatusApi() {
    return statusApi;
  }

  function useJobLabelApi() {
    return jobLabelApi;
  }

  function useWorkflowApi() {
    return workflowApi;
  }

  function useJobTemplateApi() {
    return jobTemplateApi;
  }

  function useWorkflowRunApi() {
    return workflowRunApi;
  }

  function useUserNotificationSettingApi() {
    return userNotificationSettingApi;
  }

  function useDamageApi() {
    return damageApi;
  }

  function useOrganizationNotificationSettingApi() {
    return organizationNotificationSettingApi;
  }

  function useWorkflowNotificationSettingApi() {
    return workflowNotificationSettingApi;
  }

  function usePromptApi() {
    return promptApi;
  }

  function useBoxConnectionApi() {
    return boxConnectionApi;
  }

  function useBoxImportRuleApi() {
    return boxImportRuleApi;
  }

  function useBoxExportRuleApi() {
    return boxExportRuleApi;
  }

  function useExportRunApi() {
    return exportRunApi;
  }

  function useImportRunApi() {
    return importRunApi;
  }

  function useProxyApi() {
    return proxyApi;
  }

  function useEmptyApi() {
    // 存在し得ないリクエストの場合は空のファイル一覧を返す
    const getFiles = (page: number = 1, itemsPerPage: number = 30) => {
      return Promise.resolve({
        items: [],
        page,
        itemsPerPage,
        total: 0,
      });
    };

    return { getFiles };
  }
  return {
    useUserApi,
    useSasApi,
    useFileApi,
    useStatusApi,
    useJobLabelApi,
    useWorkflowApi,
    useJobTemplateApi,
    useWorkflowRunApi,
    useUserNotificationSettingApi,
    useDamageApi,
    useOrganizationNotificationSettingApi,
    useWorkflowNotificationSettingApi,
    usePromptApi,
    useBoxConnectionApi,
    useBoxImportRuleApi,
    useBoxExportRuleApi,
    useExportRunApi,
    useImportRunApi,
    useProxyApi,
    useEmptyApi,
  };
}
